import { useContext, useEffect, useState } from "react";
import {
  authorOption,
  robotsOption,
  statusOption,
  mainUrl,
} from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddPost = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr, save, update } = useService("Data", "post");
  const { getUsers } = useService("User");
  const { setTitle } = useService("Meta");
  const { showAlert, isEmpty, generateUID, slugify } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const keywordOptions = [],
    categoryOptions = [],
    tagOptions = [];
  const [activeRobotsIndex, setactiveRobotsIndex] = useState<number>(0);
  const [activeStatusIndex, setactiveStatusIndex] = useState<number>(0);
  const [activeAuthorIndex, setactiveAuthorIndex] = useState<number>(0);
  const [image, setimage] = useState<string>("[]");
  const [uid, setuid] = useState<string>("");
  const [metaTitle, setmetaTitle] = useState<string>("");
  const [renderSlug, setrenderSlug] = useState<boolean>(true);
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [content, setcontent] = useState("");
  const [excerpt, setexcerpt] = useState("");
  const [css, setcss] = useState<string>("");
  const [js, setjs] = useState<string>("");
  const [canonical, setcanonical] = useState<string>("");
  const [robots, setrobots] = useState<string>("");
  const [metaDescription, setmetaDescription] = useState<string>("");
  const [metaKeyword, setmetaKeyword] = useState(null);
  const [author, setauthor] = useState<string>("");
  const [publishDate, setpublishDate] = useState(new Date());
  const [assignWorkers, setassignWorkers] = useState([]);
  const [status, setstatus] = useState(null);
  const [category, setcategory] = useState(null);
  const [tag, settag] = useState(null);

  const getUsersData = async () => {
    let tableData = [];
    const result = await getUsers();
    if (result.status) {
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: "No user added yet!" });
      } else {
        result.data.forEach((result) => {
          tableData.push({ label: result.name, value: result.uid });
        });
        setassignWorkers(tableData);
      }
    }
  };

  const getPostData = async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      const postData = result.data[0];
      setactiveRobotsIndex(
        robotsOption.findIndex((e) => e.value === postData.robots)
      );
      setactiveAuthorIndex(
        authorOption.findIndex((e) => e.value === postData.author)
      );
      setactiveStatusIndex(
        statusOption.findIndex((e) => e.value === postData.status)
      );
      setmetaKeyword(isEmpty(postData.metaKeyword) ? [] : postData.metaKeyword);
      settag(isEmpty(postData.tag) ? [] : postData.tag);
      setcategory(isEmpty(postData.category) ? [] : postData.category);
      settitle(postData.title);
      setmetaTitle(postData.metaTitle);
      setmode("edit");
      setslug(postData.slug);
      setcontent(postData.content);
      setexcerpt(postData.excerpt);
      setcss(postData.css);
      setjs(postData.js);
      setcanonical(postData.canonical);
      setrobots(postData.robots);
      setmetaDescription(postData.metaDescription);
      setauthor(postData.author);
      setpublishDate(new Date(postData.publishDate));
      setstatus(postData.status);
      setuid(postData.uid);
      setimage(postData.image);
    } else showAlert({ type: "error", msg: "No post added yet!" });
  };

  const addPost = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      postObject = {
        title,
        slug,
        metaTitle,
        content,
        excerpt,
        css,
        js,
        canonical,
        robots,
        metaDescription,
        metaKeyword: JSON.stringify(metaKeyword),
        author,
        publishDate,
        status: status.value,
        category: JSON.stringify(category),
        tag: JSON.stringify(tag),
        image,
        uid: mode === "add" ? generateUID() : uid,
      };
    if (title === "") {
      errorMsg = t("errorMsg.required.title");
      error = true;
    } else if (slug === "") {
      errorMsg = t("errorMsg.required.slug");
      error = true;
    } else if (content === "") {
      errorMsg = t("errorMsg.required.content");
      error = true;
    } else if (excerpt === "") {
      errorMsg = t("errorMsg.required.excerpt");
      error = true;
    } else if (author === "") {
      errorMsg = t("errorMsg.required.author");
      error = true;
    } else if (image === "") {
      errorMsg = t("errorMsg.required.image");
      error = true;
    }
    if (!error) {
      if (mode === "add") {
        const result = await save(postObject);
        if (result.status) {
          showAlert({ type: "success", msg: "Post added successfully!" });
          navigateTo({ route: "/admin/post/list" });
        } else {
          showAlert({ type: "error", msg: "Unable to add post!" });
        }
      } else {
        let data = {
          query: JSON.stringify({ uid }),
          postData: JSON.stringify(postObject),
        };
        const result = await update(data);
        if (result.status) {
          showAlert({ type: "success", msg: "Post updated successfully!" });
          navigateTo({ route: "/admin/post/list" });
        } else showAlert({ type: "error", msg: "Unable to update post!" });
      }
    } else showAlert({ type: "error", msg: errorMsg });
  };

  const urlData = urlToSplitData(getLocationData().pathname);

  setTitle("Add Post", "admin");
  useEffect(() => {
    setstatus(statusOption[activeStatusIndex].value);
    if (urlData[3] === "edit") {
      getPostData({ uid: urlData[4] });
    }
    getUsersData();
  }, []);

  const addTitle = (e) => {
    let tempTitle = e.target.value,
      tempSlug = slug;
    if (renderSlug) {
      tempSlug = slugify(tempTitle);
    }
    settitle(tempTitle);
    setslug(tempSlug);
  };

  const toggleRenderSlug = () => setrenderSlug(!renderSlug);

  const pageTitle = mode + " Post";
  if (canonical === "") {
    setcanonical(mainUrl + urlData[2] + "/" + slug);
  }
  let activeRobots = robotsOption[activeRobotsIndex],
    activeAuthor = authorOption[activeAuthorIndex],
    activeStatus = statusOption[activeStatusIndex];
  if (mode === "edit") {
    statusOption.forEach((e) => {
      if (e.value === status) activeStatus = e;
    });
    robotsOption.forEach((e) => {
      if (e.value === robots) activeRobots = e;
    });
    assignWorkers.forEach((e) => {
      if (e.value === author) activeAuthor = e;
    });
  }
  return {
    pageTitle,
    addPost,
    title,
    addTitle,
    slug,
    setslug,
    content,
    metaTitle,
    setmetaTitle,
    setcontent,
    excerpt,
    setexcerpt,
    css,
    setcss,
    js,
    setjs,
    canonical,
    setcanonical,
    activeRobots,
    setrobots,
    metaDescription,
    setmetaDescription,
    setmetaKeyword,
    keywordOptions,
    metaKeyword,
    renderSlug,
    toggleRenderSlug,
    activeAuthor,
    setauthor,
    assignWorkers,
    setpublishDate,
    publishDate,
    status,
    setstatus,
    category,
    setcategory,
    categoryOptions,
    tag,
    settag,
    tagOptions,
    image,
    setimage,
  };
};
